import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";
import LegalFooter from "../components/LegalFooter";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      const to = location.state?.from || "/app/dashboard";
      navigate(to, { replace: true });
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card" data-testid="login-card">
        <div className="flex items-center gap-2 mb-6">
          <span className="sidebar-brand-mark" />
          <span className="text-[18px] font-bold tracking-tight">Parapet</span>
        </div>
        <h1 className="mb-1">Sign in</h1>
        <p className="text-[13px] mb-6" style={{ color: "var(--parapet-text-secondary)" }}>
          Defence procurement made easy.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="p-label">Email</label>
            <input
              type="email" className="p-input" value={email}
              onChange={(e) => setEmail(e.target.value)}
              required data-testid="login-email-input" autoComplete="email"
            />
          </div>
          <div>
            <label className="p-label">Password</label>
            <input
              type="password" className="p-input" value={password}
              onChange={(e) => setPassword(e.target.value)}
              required data-testid="login-password-input" autoComplete="current-password"
            />
          </div>
          {error && (
            <div
              className="text-[12px] p-2 rounded border"
              style={{ borderColor: "#111", background: "#fafafa" }}
              data-testid="login-error"
            >
              {error}
            </div>
          )}
          <button
            type="submit" className="btn-primary w-full" disabled={loading}
            data-testid="login-submit-button"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="divider" />
        <div className="flex justify-end text-[12px]">
          <Link to="/forgot-password" className="btn-ghost px-0" data-testid="forgot-link">
            Forgot password?
          </Link>
        </div>
        <p className="text-[12px] mt-6 text-center" style={{ color: "var(--parapet-text-secondary)" }}>
          Don&rsquo;t have an account?{" "}
          <Link to="/signup" className="underline" data-testid="link-signup">Create one</Link>
        </p>
      </div>
      <LegalFooter variant="fixed" />
    </div>
  );
}
